export default __webpack_public_path__ + "static/media/tonje.bab5066d.jpg";